<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C3sfxK/tc-custom/9781466847835.jpg?1731054739230" alt="This image is the cover for the book Bitter Greens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bitter Greens
      </h1>
      <p class="bookDescription body article font2">
        <b>“Full of palace intrigue, dark magic, romance, and lush, evocative descriptions, this is historical fiction at its finest.” —<i>Library Journal</i>, starred review</b><br/><br/>The amazing power and truth of the Rapunzel fairy tale comes alive for the first time in this breathtaking tale of desire, black magic and the redemptive power of love<br/><br/>French novelist Charlotte-Rose de la Force has been banished from the court of Versailles by the Sun King, Louis XIV, after a series of scandalous love affairs. At the convent, she is comforted by an old nun, Sœur Seraphina, who tells her the tale of a young girl who, a hundred years earlier, is sold by her parents for a handful of bitter greens . . . <br/><br/>After Margherita’s father steals parsley from the walled garden of the courtesan Selena Leonelli, the famous muse of the artist Tiziano, he is threatened with having both hands cut off, unless he and his wife relinquish their precious little girl. Locked away in a tower, Margherita sings in the hope that someone will hear her. One day, a young man does.<br/><br/>Award-winning author Kate Forsyth braids together the stories of Margherita, Selena, and Charlotte-Rose, the woman who penned Rapunzel as we now know it, to create a sumptuous historical novel and a loving tribute to the imagination of one remarkable woman.<br/><br/>“Captivating.” —<i>Kirkus Reviews</i><br/><br/>“An absorbing, richly detailed, and heart-wrenching reimagining of a timeless fairytale.” —Jennifer Chiaverini, <i>New York Times</i>–bestselling author of <i>Mrs. Lincoln’s Rival</i><br/><br/>“A complex, dazzling achievement.” —Susan Vreeland, <i>New York Times</i>–bestselling author of <i>Clara and Mr. Tiffany </i>and <i>Girl in Hyacinth Blue</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Forsyth
      </h2>
      
      <p class="authorDescription body article">Kate Forsyth is the bestselling and award-winning author of more than twenty books, ranging from picture books to poetry to novels for both children and adults, including <I>the Witches of Eileanan series</I>. She is the only author to win five Aurealis Awards in a single year and was voted one of Australia's Favourite 25 Novelists. Her books have been published in fourteen countries. She completed her doctorate in fairy tale retellings at the University of Technology in Sydney in 2014. Kate lives in Sydney, Australia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b1c6f50